import { getRelationalPredicate } from './useQueryClientUtils'

export const useApiV1QueryClientUtils = () => {
  const queryClient = useQueryClient()

  interface DataShape { id: string, type: string, attributes: object }

  const replaceDataInIncludes = (data: DataShape) => {
    const { id, type, attributes } = data

    queryClient.setQueriesData<{ data: DataShape, included: DataShape | DataShape[] }>(
      {
        predicate: getRelationalPredicate(type),
      },
      oldData => oldData && oldData.included
        ? {
            ...oldData,
            included: Array.isArray(oldData.included)
              ? oldData.included.map(x => x.type === type && x.id === id
                  ? { ...x, attributes }
                  : x)
              : oldData.included.id === id
                ? { ...oldData.included, attributes }
                : oldData.included,
          }
        : undefined,
    )
  }

  const forDataInQueries = (
    type: string,
    fn: (oldData?: { data: DataShape | DataShape[] }) => { data: DataShape | DataShape[] } | undefined,
  ) => {
    queryClient.setQueriesData<{ data: DataShape | DataShape[] }>(
      {
        predicate: query => type === query.queryKey[0]
          || query.queryKey.some((keyElement: any) =>
            keyElement
            && Array.isArray(keyElement.dataType)
            && keyElement.dataType.includes(type)),
      },
      fn,
    )
  }

  const replaceDataInQueries = (data: DataShape) => {
    const { id, type, attributes } = data

    forDataInQueries(type, oldData => oldData && oldData.data
      ? {
          ...oldData,
          data: Array.isArray(oldData.data)
            ? oldData.data.map(x => x.type === type && x.id === id
                ? { ...x, attributes }
                : x)
            : oldData.data.id === id
              ? { ...oldData.data, attributes }
              : oldData.data,
        }
      : undefined)

    replaceDataInIncludes(data)
  }

  const dropDataFromQueries = (id: string, type: string) => {
    forDataInQueries(type, oldData => oldData && oldData.data
      ? {
          ...oldData,
          ...(Array.isArray(oldData.data)
            ? { data: oldData.data.filter(x => x.id !== id) }
            : {}),
        }
      : undefined)
  }

  return {
    dropDataFromQueries,
    replaceDataInQueries,
  }
}
